export const LOADING = 'LOADING'
export const LANGUAGE = 'LANGUAGE'
export const USER = 'USER'
export const USER2 = 'USER2'
export const INPUTDATA = 'INPUTDATA'
export const CLEARUSER = 'CLEARUSER'
export const INCREASE = 'INCREASE'
export const DECREASE = 'DECREASE'
export const APPID = 'APPID'
export const PAGEID = 'PAGEID'
export const RESETFLAG = 'RESETFLAG'
export const RESETFLAG2 = 'RESETFLAG2'
export const RESETID = 'RESETID'
export const RESETCOUNT = 'RESETCOUNT'
export const SIZE = 'SIZE'
export const SWITCH = 'SWITCH'
export const RESETUSER = 'RESETUSER'
